import { render } from "./ProductListPage.vue?vue&type=template&id=0370b952&ts=true"
import script from "./ProductListPage.vue?vue&type=script&lang=ts"
export * from "./ProductListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__